export const FIELD_NAME_IMAGE_AREA = 'Image area';
